var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBurntOutHeart = function SvgBurntOutHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.00555C19.9882 5.97226 19.7958 6.9282 19.4327 7.82399C17.3156 13.2843 9.99797 18 9.99797 18C9.99797 18 0 11.5657 0 5.00555C0.0263409 3.69511 0.564592 2.44724 1.49922 1.52981C2.43384 0.612375 3.69033 0.0985053 4.99899 0.0985053C6.30764 0.0985053 7.56413 0.612375 8.49876 1.52981C9.43338 2.44724 9.97163 3.69511 9.99797 5.00555C10.0243 3.69458 10.5628 2.4462 11.4978 1.52839C12.4328 0.610577 13.6898 0.0964966 14.999 0.0964966C16.3082 0.0964966 17.5652 0.610577 18.5002 1.52839C19.4352 2.4462 19.9737 3.69458 20 5.00555Z",
    fill: "white",
    fillOpacity: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurntOutHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burnt_out_heart.0435e214.svg";
export { ForwardRef as ReactComponent };